var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.991,
    height: 33.008,
    viewBox: "0 0 31.991 33.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone",
    d: "M442.583,1194.124c-3.827-3.95-6.3-7.344-7.575-10.376-1.709-4.082-1.254-7.569,1.355-10.371a1.073,1.073,0,0,1,.563-.621.321.321,0,0,0,.091-.058l2.024-2.09a2.155,2.155,0,0,1,3.037,0l4.555,4.7a2.272,2.272,0,0,1,0,3.135l-2.025,2.091a2.273,2.273,0,0,0,0,3.136l8.1,8.36a2.156,2.156,0,0,0,3.036,0l2.026-2.091a2.152,2.152,0,0,1,3.036,0l4.556,4.7a2.272,2.272,0,0,1,0,3.135l-2.025,2.091a.363.363,0,0,0-.055.094,1.073,1.073,0,0,1-.6.58,7.816,7.816,0,0,1-5.64,2.444C453.035,1202.99,448.442,1200.173,442.583,1194.124Zm-5.061-19.858c-2.314,2.39-2.706,5.3-1.2,8.895,1.2,2.857,3.577,6.1,7.273,9.919,5.5,5.675,9.894,8.433,13.442,8.433a6.429,6.429,0,0,0,4.778-2.163h0l-5.619-5.8a3.506,3.506,0,0,1-4.5-.471l-8.1-8.36a3.8,3.8,0,0,1-.456-4.651l-5.617-5.8Zm25.305,24.04,1.518-1.568a.757.757,0,0,0,0-1.045l-4.555-4.7a.722.722,0,0,0-1.012,0l-1.519,1.568ZM444.1,1178.969l1.519-1.566a.759.759,0,0,0,0-1.046l-4.555-4.7a.719.719,0,0,0-1.012,0l-1.519,1.567Z",
    transform: "translate(-433.995 -1169.983)",
    fill: "#235677"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.5905e5928c19272a238828e5b8b64dbf.svg";
export { ForwardRef as ReactComponent };